// extracted by mini-css-extract-plugin
export default {"textarea":"form-textarea_textarea__JUf5+","error":"form-textarea_error__n029s","error-message":"form-textarea_error-message__2+S-P"};